import React from 'react'
import { ChevronDown, Trash2 } from 'lucide-react'
import AddProductForm from '../../../AddProductForm'
import { ProductShort } from '../../../AddProductForm/style'
import { orderItemCardId } from '../../../../OrderForm/constants'
import { useOrderItems } from '../../contexts/OrderItemsContext'
import type { ProductApiData } from '../../types'
import {
  Card, CardActionsDiv, CardProductDiv, ProductFieldsRow, RoundCollapseButton, RoundTrashButton,
  ShortLabel, ShortLabelText, SubProductCard,
} from '../../style'
import { countColors, formatCurrency, getSafeValue } from '../../utils'
import { effectiveItemPrice, formatProductDiscountLabel } from '../../../fashionOrderDetailFromApi'

interface ProductCardProps {
  product: ProductApiData
  index: number
  isInsideKit?: boolean
}

const ProductCard: React.FC<ProductCardProps> = ({ product, index, isInsideKit = false }) => {
  const {
    addedProducts, setAddedProducts, openProductIndex, setOpenProductIndex, setIsKitMode,
    handleRemoveProduct, handleNewProductAdded, handleProductUpdated,
  } = useOrderItems()

    const totalPieces = product.sizeQuantities
    ? Object.values(product.sizeQuantities).reduce((s, q) => s + q, 0)
    : product.totalItems ?? 0

  const subtotal = effectiveItemPrice(product)

  const fields = [
    { label: 'Produto', value: product.fashionProduct?.name ?? '-' },
    { label: 'Especificação', value: product.nomeCustomizado || '-' },
    { label: 'Família', value: product.fashionProduct?.group?.family?.name || product.family?.name || '-' },
    { label: 'Cores', value: countColors(product) },
    {
      label: 'Precificação',
      value: typeof product.fashionProduct?.price === 'number'
        ? formatCurrency(product.fashionProduct.price) : '-',
    },
    { label: 'Quantidade de peças', value: totalPieces },
    { label: 'Desconto', value: formatProductDiscountLabel(product) },
    {
      label: 'Subtotal',
      value: subtotal > 0 ? formatCurrency(subtotal) : '-',
    },
  ]


  const CardComponent = isInsideKit ? SubProductCard : Card

  return (
    <CardComponent key={`${product.fashionProductId}-${index}`} id={orderItemCardId(index)}>
      <ProductShort>
        <CardProductDiv>
          <ProductFieldsRow>
            {fields.map(({ label, value }, i) => (
              <ShortLabel key={i}>
                <ShortLabelText>{label}:</ShortLabelText>&nbsp;
                {getSafeValue(value)}
              </ShortLabel>
            ))}
          </ProductFieldsRow>
          <CardActionsDiv>
            <RoundTrashButton type="button" onClick={() => handleRemoveProduct(index)}>
              <Trash2 size={16} />
            </RoundTrashButton>
            <RoundCollapseButton
              type="button"
              isOpen={openProductIndex === index}
              onClick={() => setOpenProductIndex(openProductIndex === index ? null : index)}
            >
              <ChevronDown size={16} />
            </RoundCollapseButton>
          </CardActionsDiv>
        </CardProductDiv>
      </ProductShort>

      {openProductIndex === index && (
        <div style={{ marginTop: '16px', borderTop: '1px solid #EBEBEB', paddingTop: '16px' }}>
          <AddProductForm
            order={addedProducts}
            setOrder={setAddedProducts}
            product={product}
            isEditing={true}
            onProductAdded={handleNewProductAdded}
            onProductUpdated={handleProductUpdated}
            onRemoveProduct={handleRemoveProduct}
            onClose={() => setOpenProductIndex(null)}
            isKitMode={isInsideKit}
            setIsKitMode={setIsKitMode}
          />
        </div>
      )}
    </CardComponent>
  )
}

export default ProductCard
